import React from "react";

const TickIcon = ({
  width = 12,
  height = 9,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 9"
    fill="none"
  >
    <path
      d="M3.84908 7.10067L1.05043 4.30202L0.0974121 5.24832L3.84908 8.99999L11.9027 0.946321L10.9564 1.52588e-05L3.84908 7.10067Z"
      fill="white"
    />
    <mask
      id="mask0_2119_6090"
      //   style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="12"
      height="9"
    >
      <path
        d="M3.84908 7.10067L1.05043 4.30202L0.0974121 5.24832L3.84908 8.99999L11.9027 0.946321L10.9564 1.52588e-05L3.84908 7.10067Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_2119_6090)">
      <path
        d="M-2.19116 -3.75165H13.9162V12.3557H-2.19116V-3.75165Z"
        fill="white"
      />
    </g>
  </svg>
);

export default TickIcon;
